<div [ngStyle]="{ 'margin-top': '15px' }" #quickPay>
	<!-- A Stripe Element will be inserted here. -->
</div>
